import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { TableName } from "../constants/tableName";

export class NewsController {
  static TABLE_NAME = TableName.NEWS;

  static getAll = ({ resolve, reject }) => {
    let errorMessage =
      "Unable to get all the news.\nPlease contact administrator for assistance.";
    getDocs(collection(db, this.TABLE_NAME))
      .then((data) => {
        console.debug(data);
        resolve(data);
      })
      .catch((error) => {
        reject(
          this.errorHandling({ errorMessage: errorMessage, error: error })
        );
      });
  };

  static errorHandling = ({ errorMessage, error }) => {
    switch (error.code) {
      case "permission-denied":
        errorMessage = "You are not authorised for this action.";
        break;
      default:
        break;
    }
    console.debug(error.message);
    return errorMessage;
  };
}
